import { useQuery } from '@tanstack/react-query';

import { InviteConfirmationModel } from '../../models/invite.model';

import API from '../../services/api';

const checkInvite = async (
    inviteCode: string | null,
): Promise<InviteConfirmationModel | null> => {
    if (inviteCode) {
        const { data } = await API.checkInviteCode(inviteCode);
        return data;
    } else {
        return null;
    }
};

export default function useInviteQuery(inviteCode: string | null) {
    return useQuery({
        queryKey: ['invite', inviteCode],
        queryFn: () => checkInvite(inviteCode),
        enabled: Boolean(inviteCode),
    });
}
